// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"EditProfilesModal_modalContainer__2YtPR","closeButton":"EditProfilesModal_closeButton__3KaJi","footer":"EditProfilesModal_footer__2jmaC"};